'use client';
import React, { useEffect, useState } from 'react';
import { BundledProductDetail as SharedBundledProductDetail } from '@launchstore/shared-puck';
import type {
  BundledProductDetailProps, BundleData, BundleAddItemsArg,
} from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import { useCart } from '@/lib/hooks/useCart';
import { getBundleProduct, addBundleToCart } from '@/lib/data/bundles';

const SharedBundledProductDetailRender = (SharedBundledProductDetail as any).render;

const BundledProductDetailImpl: React.FC<BundledProductDetailProps> = (props: any) => {
  const { product, region } = useProduct() as any;
  const { cart, refreshCart, isLoading: cartLoading } = useCart();
  const [bundle, setBundle] = useState<BundleData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [adding, setAdding] = useState(false);
  const bundleId = (props.bundleIdOverride as string) || (product?.metadata as any)?.bundle_id;

  useEffect(() => {
    if (!bundleId) { setBundle(null); setError(null); return; }
    setLoading(true);
    setError(null);
    getBundleProduct(bundleId, region?.id, region?.currency_code)
      .then((data: any) => setBundle(data as BundleData))
      .catch((err: any) => setError(err?.message ?? 'Failed to load bundle'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bundleId, region?.id, region?.currency_code]);

  const onAdd = async (items: BundleAddItemsArg) => {
    if (!cart?.id || !bundleId) return;
    setAdding(true);
    try {
      await addBundleToCart(cart.id, bundleId, items, 1);
      await refreshCart();
    } finally { setAdding(false); }
  };

  return (
    <SharedBundledProductDetailRender
      {...(props as any)}
      bundle={bundle}
      isLoading={loading}
      error={error}
      isAdding={adding || !!cartLoading}
      onAdd={onAdd}
    />
  );
};

export const BundledProductDetail: any = { ...SharedBundledProductDetail, render: (props: any) => <BundledProductDetailImpl {...props} /> };
export default BundledProductDetail;
